// A window that shrinks its own content step by step until nothing in it scrolls (owner 2026-10-26: "na żadnym
// ekranie" a scroll bar, on low phones held sideways the buttons went off the screen). The window gets data-fit-1 ..
// data-fit-<steps>, one more while its body or its scroller still overflows; its stylesheet says what each step
// drops or makes smaller (the Kierki score window: hearts.css; No moves: windows.css; Win: win.css). Measured on
// open, again once it has opened, on a resize of the window or a part of it, when the ad comes, and on a change of
// `key`. The room of the ad is AdSlot.tsx's business (useAdRoom): this only fits the rest.
import { useLayoutEffect } from 'react';

export function useFitWindow(selector: string, steps: number, key: unknown): void {
  useLayoutEffect(() => {
    const win = document.querySelector<HTMLElement>(selector);
    const box = win?.querySelector<HTMLElement>('.lbx_content');
    if (!win || !box) return;
    let busy = false;
    const overflows = () => [box, ...box.querySelectorAll<HTMLElement>('.tab_contents')].some((el) => el.scrollHeight > el.clientHeight + 1);
    const fit = () => {
      if (busy) return;
      busy = true;
      for (let k = 1; k <= steps; k++) win.removeAttribute(`data-fit-${k}`);
      for (let k = 1; k <= steps && overflows(); k++) win.setAttribute(`data-fit-${k}`, '');
      busy = false;
    };
    fit();
    // again once the window has opened (its opening animation and late lines changed the room)
    const later = [450, 1000, 2000].map((ms) => window.setTimeout(fit, ms));
    win.addEventListener('transitionend', fit);
    const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(() => requestAnimationFrame(fit)) : null;
    ro?.observe(win);
    ro?.observe(box);
    // the ad's box fills later and may be replaced by the vendor (only the ad boxes: the Win window's counters and
    // confetti change all the time)
    const ads = [...win.querySelectorAll<HTMLElement>('.ads')];
    const watchAds = () => {
      for (const a of ads) {
        ro?.observe(a);
        for (const el of a.querySelectorAll('*')) ro?.observe(el);
      }
    };
    watchAds();
    const mo = typeof MutationObserver === 'function' ? new MutationObserver(() => {
      watchAds();
      requestAnimationFrame(fit);
    }) : null;
    for (const a of ads) mo?.observe(a, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-ad-hidden', 'data-filled'] });
    addEventListener('resize', fit);
    return () => {
      later.forEach((id) => window.clearTimeout(id));
      win.removeEventListener('transitionend', fit);
      ro?.disconnect();
      mo?.disconnect();
      removeEventListener('resize', fit);
    };
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps -- selector and steps are constants of a window
}
